/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-multi-assign */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom'
import { ConfigProvider as AntdConfigProvider } from 'antd'
import enUS from 'antd/lib/locale/en_US'
import zhCN from 'antd/lib/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import loadable from '@loadable/component'
import ScrollToTop from '@openplatform/components/ScrollToTop'
import { REFRESH_BROWSER, CHANGE_LANGUAGE, COUNTRIES_AREAS } from '@openplatform/store/actionTypes/homepage'
import { isH5 } from '@openplatform/utils'
import useCountryCode from '@/hooks/basic-sdk/useCountryCode'
import { immutableSelector } from '@/utils/index'

const LoadableHome = loadable(() => import('@openplatform/pages/Home'))
// const LoadableAdmin = loadable(() => import('@openplatform/pages/Admin'))
// const LoadableRegister = loadable(() => import('@openplatform/pages/User/Register'))

// 初始化 sentry(108: 产线)
const isPro = process.env.NODE_ENV === 'production'
const defaultCode = 7
const env = isPro ? 'pro' : 'testing'
const sentryConfig = new window.ApiConfig({
  env,
  defaultCode,
  sentry: {
    pro: {
      // 中国产线
      id: 'b667cd98b8004fa9a5e6567b3c302cab',
      path: '108'
    },
    testing: {
      // 测试环境
      id: '416aef6dd4014d01b13ee18bd13a8733',
      path: '109'
    },
    us: {
      // 产线 us 暂时没有
      id: '',
      path: ''
    },
    in: {
      // 产线 in 暂时没有
      id: '',
      path: ''
    },
    de: {
      // 产线 de 暂时没有
      id: '',
      path: ''
    },
    ru: {
      // 产线 ru 暂时没有
      id: '',
      path: ''
    },
    sg: {
      // 产线 sg 暂时没有
      id: '',
      path: ''
    }
  }
})
sentryConfig.sentryInstall()

export default function App() {
  const match = useRouteMatch()

  const i18n = useSelector((state: any) => {
    const { i18n } = immutableSelector(state)
    return i18n
  })
  const dispatch = useDispatch()
  const [isH5Page, setIsH5Page] = useState(isH5())

  const refreshAppCls = useCallback(() => {
    const oldH5 = isH5Page
    const newH5 = isH5()
    if (newH5 === oldH5) return
    setIsH5Page(newH5)
  }, [isH5Page])

  const { areas, countries, recommendCountry } = useCountryCode()

  useEffect(() => {
    // 切换 H5 跟 PC
    window.addEventListener('resize', refreshAppCls)
    // 获取用户缓存语言
    const currentLang = localStorage.getItem('curLang')
    // 获取浏览器语言
    const { getLocaleLanguage } = window as any
    const { lang, defaultLang } = getLocaleLanguage && getLocaleLanguage(window.navigator, 'en')
    // 如果用户浏览器是除 zh en 以外的其他语言统一设置成 en
    const language = lang !== 'zh' && lang !== 'en' ? defaultLang : lang
    dispatch({ type: REFRESH_BROWSER })
    dispatch({ type: CHANGE_LANGUAGE, payload: currentLang || language || 'en' })
    dispatch({
      type: COUNTRIES_AREAS,
      payload: {
        areas,
        countries,
        recommendCountry
      }
    })

    return () => {
      window.removeEventListener('resize', refreshAppCls)
    }
  }, [dispatch, refreshAppCls, areas, countries, recommendCountry])

  // 多语言加载下来后再加载页面
  const { platform } = i18n
  if (!platform || JSON.stringify(platform) === '{}') return null
  const currentLanguage = i18n?.currentLanguage || 'zh'

  return (
    <AntdConfigProvider locale={currentLanguage === 'en' ? enUS : zhCN}>
      <div style={{ height: '100%' }} className={isH5Page ? 'h5' : ''}>
        <ScrollToTop>
          <Switch>
            <Route path={`${match.path}home`} component={LoadableHome} />
            {/* <Route path={`${match.path}user/register`} component={LoadableRegister} />
            <Route path={`${match.path}admin`} component={LoadableAdmin} /> */}
            <Redirect from="/*" to="/home" />
          </Switch>
        </ScrollToTop>
      </div>
    </AntdConfigProvider>
  )
}
